import React from 'react';
import * as styles from './index.module.scss';
import { GatsbyImage } from "gatsby-plugin-image";

import RichText from '../../../lib/contentful/rich-text';

export const Card = ({ card }) => {
    return(
        <div
            className={styles.wrapper}
            style={{background: card.backgroundColour,color: card.textColour}}
        >
            <GatsbyImage
                alt={`${card?.alt}`}
                className={styles.image}
                image={card?.image?.gatsbyImageData}
                style={{maxWidth:card.imageMaxWidthPx + "px"}}
            />
            <div>
                <h3
                    className={styles.title}
                >{card?.title}</h3>
                {RichText(card?.text)}
            </div>
        </div>
    )
}

export const LinkCard = ({ card }) => {
    return(
        <a
            className={styles.wrapper}
            href={`${card?.url}`}
            style={{background: card.backgroundColour,color: card.textColour}}
        >
            <GatsbyImage
                alt={`${card?.alt}`}
                className={styles.image}
                image={card?.image?.gatsbyImageData}
                style={{maxWidth:card.imageMaxWidthPx + "px"}}
            />
            <div>
                <h2
                    className={styles.title}
                >{card?.title}</h2>
                {RichText(card?.text)}
            </div>
                <span
                    className={styles.learnMore}
                >Learn More</span>
        </a>
    )
}